export var BusinessMembershipStatus;
(function (BusinessMembershipStatus) {
    BusinessMembershipStatus["Invited"] = "invited";
    BusinessMembershipStatus["Active"] = "active";
    BusinessMembershipStatus["Suspended"] = "suspended";
})(BusinessMembershipStatus || (BusinessMembershipStatus = {}));
//# sourceMappingURL=business-membership-status.const.js.map